export default __webpack_public_path__ + "static/ely-7-a9a13ad115eb3973ca29037f73d2265d.jpg";